import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axiosHttp from "../config/axios.interceptor";
import Loader from "../components/Loader";
import { useDispatch } from "react-redux";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import { AuthContext } from "../contexts/AuthContext";
import { AppContext } from "../contexts/AppContext";
import { errorResponseMessage } from "../shared/const.prop";
import { toast } from "react-toastify";

const AskQuery = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname.trim().split("/")[2];
  const type = location?.state?.type;
  const [serviceList, setServiceList] = useState([]);
  const [name, setName] = useState({
    id: "",
    serviceName: "",
  });
  const [reason, setReason] = useState("");
  const [noService, setNoService] = useState(false);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [expertise, setExpertise] = useState("");
  const [duration, setDuration] = useState(1);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [expertiseList, setExpertiseList] = useState([]);
  const [error, setError] = useState("");
  const [subscriptionExpiryDate, setSubscriptionExpiryDate] = useState();
  const [otherProfile, setOtherProfile] = useState({});
  const [category, setCategory] = useState(type ? type : "");
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const { user, logout } = authContext;
  const [session, setSession] = useState([
    {
      startDate: "",
      endDate: "",
    },
  ]);

  const subscriptionPlan =
    user?.subscription?.main_plan_name ||
    user?.data?.data?.subscription?.main_plan_name;

  useEffect(() => {
    setLoading(true);
    // if (subscriptionPlan !== "Premium") {
    //   console.log("query 1");
    //   appContext.updateNotificationState({
    //     show: true,
    //     type: "error",
    //     message: "Upgrade to premium plan to view this screen",
    //   });
    //   navigate("../myspace");
    // }
    fetchProfile();
    dispatch(getActiveNotificationCount());
    dispatch(getActiveChatNotificationCount());
  }, []);

  const fetchProfile = () => {
    setLoading(true);
    axiosHttp
      .get("profile/" + id)
      .then((apiResponse) => {
        if (apiResponse.status === 200) {
          // if (
          //   apiResponse?.data?.data?.subscription?.main_plan_name !== "Premium"
          // ) {
          //   appContext.updateNotificationState({
          //     show: true,
          //     type: "error",
          //     message: "Upgrade to premium plan to view this screen",
          //   });
          //   navigate("../myspace");
          // } else {
          //   setSubscriptionExpiryDate(
          //     apiResponse?.data?.data?.subscription?.end_date
          //   );
          //   getExpertiseData();
          // }
          setOtherProfile(apiResponse?.data?.data?.subscription);
          if (apiResponse?.data?.data?.subscription?.end_date) {
            setSubscriptionExpiryDate(
              apiResponse?.data?.data?.subscription?.end_date
            );
          }
          if (
            apiResponse?.data?.data?.subscription?.main_plan_name === "Basic"
          ) {
            setNoService(true);
            setLoading(false);
          } else {
            getExpertiseData();
          }
        } else {
          appContext.updateNotificationState({
            show: true,
            type: "error",
            message: "Error, please try after sometime.",
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 429) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
          logout();
        }
        if (error.response.status === 400) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
        }
        appContext.updateNotificationState({
          show: true,
          type: "error",
          message: "Error, please try after sometime.",
        });
      });
  };

  const today = new Date();

  const isDateBeforeToday = (date) => {
    return date.isBefore(today, "day");
  };

  const options = {
    minDate: today,
    maxDate: new Date(subscriptionExpiryDate),
    isInvalidDate: isDateBeforeToday,
  };

  const fetchOtherServices = async () => {
    setLoading(true);
    try {
      const getOthersServiceList = await axiosHttp.get(`users/${id}/services`);
      if (getOthersServiceList.status === 200) {
        let data = getOthersServiceList.data.data;
        setServiceList(data.reverse());
        setLoading(false);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response.status === 422) {
        setNoService(true);
      }
      if (error.response.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      //console.log(error);
      setLoading(false);
    }
  };

  const getExpertiseData = async () => {
    setLoading(true);
    try {
      const getExpertiseList = await axiosHttp.get(`profile/${path}`);
      if (getExpertiseList.status === 200) {
        let data = getExpertiseList.data.data;
        setExpertiseList(data.experties);
        fetchOtherServices();
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      //console.log(error);
    }
  };

  const handleSelectChange = (e) => {
    const selectedId = e.target.value;
    const selectedServiceName = e.target.options[e.target.selectedIndex].text;
    setName((prevName) => ({
      ...prevName,
      id: e.target.value,
      serviceName: e.target.options[e.target.selectedIndex].text,
    }));
    sessionStorage.setItem("service", selectedServiceName);
    if (selectedServiceName !== "Single session") {
      setDuration(1);
      setSession([
        {
          startDate: "",
          endDate: "",
        },
      ]);
    }
  };

  const handleEvent = (event, picker, index) => {
    let service = sessionStorage.getItem("service");
    if (picker !== null) {
      let startDate = moment(picker.startDate);
      let endDate = moment(picker.endDate);

      let daysDiff = endDate.diff(startDate, "days") + 1;

      if (service === "weekly sessions" && daysDiff > 7) {
        toast.error("Weekly sessions can only span up to 7 days.");
        setSession((prevSession) => {
          const newSession = [...prevSession];
          newSession[index] = {
            startDate: "",
            endDate: "",
          };
          return newSession;
        });
        return;
      } else if (service === "monthly sessions") {
        if (endDate.diff(startDate, "months") > 0) {
          toast.error("Monthly sessions can only span up to 1 month.");

          endDate = moment(startDate).add(1, "month").subtract(1, "day");
          picker.setEndDate(endDate.toDate());
          setSession((prevSession) => {
            const newSession = [...prevSession];
            newSession[index] = {
              startDate: `${startDate.format("YYYY-MM-DD")}T00:00:00Z`,
              endDate: `${endDate.format("YYYY-MM-DD")}T00:00:00Z`,
            };
            return newSession;
          });
          return;
        }
      }

      setSession((prevSession) => {
        const newSession = [...prevSession];
        newSession[index] = {
          startDate: `${startDate.format("YYYY-MM-DD")}T00:00:00Z`,
          endDate: `${endDate.format("YYYY-MM-DD")}T00:00:00Z`,
        };
        return newSession;
      });
    }
  };

  const handleSubmit = () => {
    if (
      otherProfile?.main_plan_name === "Basic" ||
      subscriptionPlan === "Basic"
    ) {
      appContext.updateModalType("subscriptionAlert", "Subscription", {
        name: subscriptionPlan,
        content:
          subscriptionPlan === "Basic"
            ? "Please subscribe to premium plan to avail this service"
            : "This user is not subscribed to the Premium plan, so you cannot book his/her services.",
      });
      return;
    }
    if (category === "") {
      setError("Service type is required");
    } else if (category === "Upskilling services") {
      if (expertise === "") {
        setError("Expertise required");
      } else if (name.serviceName === "") {
        setError("Type of service required");
      } else if (
        name.serviceName !== "Single session" &&
        !validateDateRanges(session)
      ) {
      } else if (reason === "") {
        setError("Reason required");
      } else {
        addQuery();
      }
    } else if (reason === "") {
      setError("Reason required");
    } else {
      addQuery();
    }
  };

  const addQuery = async () => {
    setLoading(true);
    let payload = {};
    if (category === "Upskilling services") {
      if (name.serviceName === "Single session") {
        payload = {
          serviceId: name.id,
          receiverId: id,
          message: reason,
          expertise: expertise,
          serviceName: name.serviceName,
          category: category,
        };
      } else {
        let durationName = "";
        durationName =
          name.serviceName === "weekly sessions"
            ? `${duration} Weeks`
            : `${duration} Months`;
        payload = {
          serviceId: name.id,
          serviceName: name.serviceName,
          receiverId: id,
          duration: durationName,
          message: reason,
          dates: session,
          expertise: expertise,
          category: category,
        };
      }
    } else {
      payload = {
        receiverId: id,
        category: category,
        message: reason,
      };
    }

    try {
      const queryAdd = await axiosHttp.post(`queries`, { ...payload });
      if (queryAdd.status === 201) {
        let data = queryAdd?.data?.data;
        dispatch(getActiveNotificationCount());
        navigate("/myspace/queries");
        setLoading(false);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response.status === 422) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      //console.log(error);
      setLoading(false);
    }
  };
  const handleNavigation = () => {
    navigate(`../user/${path}/services`);
  };

  const addDateHandler = () => {
    if (duration === 3) {
      toast.error("Maximum duration limit reached");
    } else {
      setDuration(duration + 1);

      let tempArr = [...session];

      let dateObj = {
        startDate: "",
        endDate: "",
      };
      tempArr.push(dateObj);
      setSession(tempArr);
    }
  };

  const removeDateHandler = (val) => {
    setDuration(duration - 1);
    let tempArr = session.filter((_, index) => index !== val);
    setSession(tempArr);
  };

  function validateDateRanges(arr) {
    arr.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

    for (let i = 0; i < arr.length; i++) {
      const { startDate, endDate } = arr[i];

      if (!startDate || !endDate) {
        setError(
          `Missing startDate or endDate at ${
            name.serviceName === "weekly sessions" ? "week" : "month"
          } ${i + 1}.`
        );
        return false;
      }

      if (new Date(startDate) >= new Date(endDate)) {
        setError(
          `End date must be after start date at ${
            name.serviceName === "weekly sessions" ? "week" : "month"
          } ${i + 1}.`
        );
        return false;
      }

      if (i > 0) {
        const prevEndDate = new Date(arr[i - 1].endDate);
        if (new Date(startDate) <= prevEndDate) {
          toast.error("Dates are overlapping, please check");
          setError(`Dates are overlapping, please check`);
          return false;
        }
      }
    }

    return true;
  }

  return loading ? (
    <Loader />
  ) : (
    <div className="card card-one-1 height mb-5">
      <div className="card-body">
        <p className="title cursor-pointer" onClick={handleNavigation}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M16.6667 10.2285C16.6667 10.5449 16.4316 10.8064 16.1266 10.8478L16.0417 10.8535L5.05508 10.853L9.02424 14.8059C9.26884 15.0495 9.26969 15.4452 9.02614 15.6898C8.80473 15.9122 8.45755 15.9331 8.21249 15.7521L8.14226 15.6917L3.10059 10.6717C3.06835 10.6396 3.04035 10.6049 3.01658 10.5682C3.00986 10.5571 3.00303 10.5458 2.99655 10.5343C2.99059 10.5244 2.98521 10.5142 2.98013 10.5038C2.97307 10.4887 2.96618 10.4731 2.95992 10.4572C2.95483 10.445 2.95059 10.433 2.94671 10.421C2.94211 10.4061 2.93764 10.3902 2.93379 10.3741C2.93093 10.3628 2.92866 10.352 2.92668 10.3411C2.9239 10.3249 2.92154 10.3081 2.91985 10.2912C2.91839 10.2782 2.91752 10.2654 2.91703 10.2526C2.91691 10.2448 2.91675 10.2367 2.91675 10.2285L2.91706 10.2043C2.91754 10.192 2.91838 10.1798 2.91958 10.1675L2.91675 10.2285C2.91675 10.1891 2.9204 10.1505 2.92739 10.1131C2.92901 10.1041 2.93094 10.095 2.93308 10.0858C2.93752 10.067 2.94265 10.0489 2.94855 10.0311C2.95146 10.0223 2.95483 10.0129 2.95844 10.0035C2.96575 9.98471 2.97369 9.96678 2.98242 9.94932C2.98648 9.94111 2.99102 9.93251 2.99578 9.924C3.00359 9.91012 3.01163 9.89693 3.02014 9.88407C3.02614 9.87497 3.03279 9.8655 3.03973 9.85617L3.04514 9.84897C3.06198 9.82697 3.08025 9.80612 3.09981 9.78657L3.10056 9.78599L8.14222 4.76515C8.3868 4.52158 8.78253 4.5224 9.0261 4.76698C9.24753 4.98933 9.26699 5.33659 9.08493 5.58089L9.02427 5.65086L5.05675 9.60301L16.0417 9.60351C16.3869 9.60351 16.6667 9.88333 16.6667 10.2285Z"
              fill="black"
              fillOpacity="0.6"
            />
          </svg>
          Query
        </p>
        <>
          {noService ? (
            <p>No services available</p>
          ) : (
            <div>
              <div className="query-container mt-2 w-100">
                <div className="query-wrapper w-100">
                  <div className="d-flex justify-content-start align-items-center w-100">
                    <div className="query-align-wrap">
                      <label htmlFor="expertiseList">
                        I would like your assistance in{" "}
                        {/* <span className="red">*</span> */}
                      </label>
                      <select
                        className="form-control"
                        value={category}
                        h
                        onChange={(e) => setCategory(e.target.value)}
                        name="category"
                        id="category"
                      >
                        <option value="">Please select</option>
                        <option value="Upskilling services">
                          Upskilling services
                        </option>
                        <option value="Freelancing services">
                          Freelancing services
                        </option>
                      </select>{" "}
                      {/* {category === "Upskilling services" && "of"} */}
                      {category === "Upskilling services" && (
                        <select
                          className="form-control"
                          value={expertise}
                          h
                          onChange={(e) => setExpertise(e.target.value)}
                          name="expertiseList"
                          id="expertiseList"
                        >
                          <option value="">Please select</option>
                          {expertiseList.map((item) => {
                            return (
                              <option value={item.value}>{item.value}</option>
                            );
                          })}
                        </select>
                      )}
                      {/* {category === "Upskilling services" && (
                        <span className="red">*</span>
                      )} */}
                    </div>

                    {/* <div>
                      {name.serviceName !== "Single session" &&
                        name.serviceName !== "" &&
                        name && <p className="ml-2">for</p>}
                    </div> */}
                  </div>
                  <div className="d-flex justify-content-start align-items-center flex-wrap w-100 ask-query-body">
                    {category === "Upskilling services" && (
                      <div className="query-align-wrap">
                        <div
                          className={`ask-query-wrapper ${
                            name.serviceName === "Single session"
                              ? "query-align-wrap"
                              : null
                          }`}
                        >
                          <div>
                            {name.serviceName === "Single session" && (
                              <p className="book-query">
                                So I would like to book{" "}
                              </p>
                            )}
                          </div>
                          {/* <span className="red">*</span> */}
                          <select
                            className="form-control"
                            value={name.id}
                            onChange={handleSelectChange}
                          >
                            <option value="">Please select</option>
                            {serviceList.map((service) => {
                              return (
                                <option value={service.id}>
                                  {service.serviceName}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    )}
                    {name.serviceName === "Single session" && (
                      <p className="sess-query"> session with you</p>
                    )}
                  </div>
                  <div className="d-flex justify-content-start align-items-center flex-wrap w-100 ask-query-footer">
                    <div className="ask-query-wrapper"></div>
                    {/* <div>
                {name.serviceName === "weekly sessions" && <span>Weeks</span>}
                {name.serviceName === "monthly sessions" && <span>Months </span>}
              </div> */}

                    {name.serviceName !== "Single session" &&
                      name &&
                      name.serviceName !== "" && (
                        <>
                          {session.length > 0 &&
                            session.map((item, index) => {
                              const {
                                startDate = new Date(),
                                endDate = new Date(),
                              } = item;

                              return (
                                <div>
                                  <div className="d-flex w-100">
                                    <DateRangePicker
                                      alwaysShowCalendars={true}
                                      onEvent={(event, picker) =>
                                        handleEvent(event, picker, index)
                                      }
                                      initialSettings={options}
                                      minDate={new Date()}
                                      maxDate={
                                        new Date(
                                          Date.parse(subscriptionExpiryDate)
                                        )
                                      }
                                    >
                                      <button className="btn range-btn ask-query-wrapper">
                                        {startDate !== ""
                                          ? moment(startDate).format(
                                              "DD MMM YYYY"
                                            )
                                          : moment(new Date()).format(
                                              "DD MMM YYYY"
                                            )}{" "}
                                        -{" "}
                                        {endDate !== ""
                                          ? moment(endDate).format(
                                              "DD MMM YYYY"
                                            )
                                          : moment(new Date()).format(
                                              "DD MMM YYYY"
                                            )}
                                      </button>
                                    </DateRangePicker>
                                    <div class="d-flex scheduleCreation-cntrol">
                                      <span onClick={addDateHandler}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="19"
                                          height="19"
                                          viewBox="0 0 19 19"
                                          fill="none"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M13.0122 0.791748C15.8835 0.791748 17.8128 2.80733 17.8128 5.80696V12.7974C17.8128 15.797 15.8835 17.8126 13.0122 17.8126H5.59266C2.72128 17.8126 0.791992 15.797 0.791992 12.7974V5.80696C0.791992 2.80733 2.72128 0.791748 5.59266 0.791748H13.0122ZM13.0122 1.97925H5.59266C3.39816 1.97925 1.97949 3.48104 1.97949 5.80696V12.7974C1.97949 15.1233 3.39816 16.6251 5.59266 16.6251H13.0122C15.2075 16.6251 16.6253 15.1233 16.6253 12.7974V5.80696C16.6253 3.48104 15.2075 1.97925 13.0122 1.97925ZM9.30241 5.80086C9.63016 5.80086 9.89616 6.06686 9.89616 6.39461V8.7005L12.2051 8.70066C12.5328 8.70066 12.7988 8.96666 12.7988 9.29441C12.7988 9.62216 12.5328 9.88816 12.2051 9.88816L9.89616 9.888V12.1952C9.89616 12.5229 9.63016 12.7889 9.30241 12.7889C8.97466 12.7889 8.70866 12.5229 8.70866 12.1952V9.888L6.39976 9.88816C6.07122 9.88816 5.80601 9.62216 5.80601 9.29441C5.80601 8.96666 6.07122 8.70066 6.39976 8.70066L8.70866 8.7005V6.39461C8.70866 6.06686 8.97466 5.80086 9.30241 5.80086Z"
                                            fill="black"
                                          />
                                        </svg>
                                      </span>
                                      {index > 0 && (
                                        <span
                                          onClick={() =>
                                            removeDateHandler(index)
                                          }
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="19"
                                            height="19"
                                            viewBox="0 0 19 19"
                                            fill="none"
                                          >
                                            <rect
                                              width="19"
                                              height="3"
                                              rx="1.5"
                                              fill="black"
                                            />
                                          </svg>
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                        </>
                      )}
                    {/* {name.serviceName !== "Single session" &&
                      name &&
                      name.serviceName !== "" && (
                        <div>
                          <button
                            className="btn btn-primary"
                            onClick={dateRangeHandler}
                          >
                            Add
                          </button>
                        </div>
                      )} */}
                  </div>
                </div>
              </div>
              {category === "Freelancing services" && (
                // <div className="row mt-4">
                <p>
                  <b>Note</b> : It is only possible to send the query once
                </p>
                // </div>
              )}
              <div className="row mt-4">
                <textarea
                  className="form-control box-col"
                  id=""
                  rows="5"
                  placeholder="Comment"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                ></textarea>
              </div>

              <div className="row">
                <div className="col-md-12">
                  {error && <p className="form-error mt-4">{error}</p>}
                  <div className="d-flex mt-4">
                    {/* <button
                type="button"
                className="btn btn-outline-primary prime-btn mx-3"
                data-dismiss="modal"
              >
                Cancel
              </button> */}
                    <button
                      type="button"
                      className="btn btn-primary modal-btn"
                      // disabled={reason === "" || name === ""}
                      onClick={handleSubmit}
                    >
                      Send
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      </div>
    </div>
  );
};

export default AskQuery;
